module.exports = __webpack_public_path__ + "assets/img/icon-user-bg.1f790f94.png";